import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { STREAM_TABS, type StreamTab } from '@/features/admin/shared/tabs';
import { StreamDetailPage } from '@/features/admin/streams/stream-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Détail d'un stream. L'onglet actif vit dans l'URL (`?tab=`). */
export const Route = createFileRoute('/$tenant/streams/$streamId')({
  validateSearch: (search: Record<string, unknown>): { tab: StreamTab } => ({
    tab: STREAM_TABS.parse(search['tab']),
  }),
  component: StreamRoute,
});

function StreamRoute() {
  const { tenant, streamId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="streams"
      crumbs={[{ label: t('nav.items.streams') }, { label: streamId, mono: true }]}
    >
      <StreamDetailPage
        tenantId={tenant}
        streamId={streamId}
        tab={tab}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
